export const URLS = {
  home: "/",
  careers: "/careers",
  contactUs: "/contact-us",
  overview: "/overview",
  visionAndMission: "/vision-and-mission",
  subsidiaries: "/subsidiaries",
  awardsAndRecognitions: "/awards-and-recognitions",
  steelSector: "/steel-sector",
  havcSector: "/havc-sector",
  insulationSector: "/insulation-sector",
  constructionSector: "/construction-sector",
  investorRelations: "/investor-relations",
  financialStatements: "/financial-statements",
  annualReports: "/annual-reports",
  generalAssembly: "/general-assembly",
  pressReleases: {
    root: "/press-releases",
    view: (id: number) => `/press-releases/${id}`,
  },
  newsletters: {
    root: "/newsletters",
    view: (id: number) => `/newsletters/${id}`,
  },
  mediaKit: "/media-kit",
  termsOfUse: "/terms-of-use",
  privacyPolicy: "/privacy-policy",

  // Sectors
  sectorsSection: "/", // Link to home page where sectors are displayed
  sectors: {
    root: "/sectors",
    view: (sector: string) => `/sectors/${sector}`,
  },

  // About Us section
  aboutUs: {
    root: "/about-us",
    // Now using search params: /about-us?tab=boardOfDirectors, /about-us?tab=leadershipWord, etc.
  },

  investor: {
    root: "/investor-relations",
    financialInfo: "/investor-relations/financial-information",
    factSheet: "/investor-relations/fact-sheet",
    investmentCase: "/investor-relations/investment-case",
    shareInformation: "/investor-relations/share-information",
    financialCalendar: "/investor-relations/financial-calendar",
    keyFigures: "/investor-relations/key-figures",
    dividendInformation: "/investor-relations/dividend-information",
    companyAnnouncements: "/investor-relations/company-announcements",
    analysisCoverage: "/investor-relations/analysis-coverage",
    contactIr: "/investor-relations/contact-ir",
    basicInfo: "/investor-relations/basic-info",
    boardOfDirectors: "/investor-relations/board-of-directors",
    sharePerformance: "/investor-relations/share-performance",
    governanceAndRegulatoryDocuments:
      "/investor-relations/governance-and-regulatory-documents",
    generalAssembly: {
      root: "/investor-relations/general-assembly",
      minutesOfMeetingsAvailable:
        "/investor-relations/general-assembly/minutes-of-meetings-available",
      announcements: {
        root: "/investor-relations/general-assembly/announcements",
        view: (id: number) =>
          `/investor-relations/general-assembly/announcements/${id}`,
      },
    },
    dividendsAndShareholders: "/investor-relations/dividends-and-shareholders",
    quarterlyReports: {
      view: (id: number) =>
        `/investor-relations/financial-information/quarterly-reports/${id}`,
    },
    emailSubscriptionCenter: "/investor-relations/email-subscription-center",
  },
};

export const apiUrls = {
  financialInformation: {
    annualReports: "/investor-relations/financial-information/reports",
    financialStatements: "/investor-relations/financial-information/statements",
    quarterlyReports:
      "/investor-relations/financial-information/quarterly-reports",
  },
  generalAssembly: {
    minutesOfMeetingsAvailable:
      "/investor-relations/general-assembly/minutes-of-meetings-available",
    announcements: "/investor-relations/general-assembly/announcements",
  },
  investor: {
    sharePerformance: "/investor-relations/share-performance",
  },
};
